import { render, staticRenderFns } from "./DPMultiple.vue?vue&type=template&id=e85ed5a8&"
import script from "./DPMultiple.vue?vue&type=script&lang=js&"
export * from "./DPMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports